if (!window.__mpjJsLoaded) {
  window.__mpjJsLoaded = true;

  /* ---------------- Suivi (dataLayer) ----------------
     Evenements : hero_cta_click, before_after_interaction, style_switch_click,
     pricing_view, package_select, start_project, photos_uploaded, budget_completed,
     checkout_started, project_form_step_N. Evenements prevus pour l'espace projet
     (markup a poser avec data-mpj-track="...") : direction_selected, revision_requested,
     extra_revision_purchase, shopping_product_click. L'evenement purchase doit etre
     emis par le pixel Shopify (Customer events), pas par le theme. */
  window.dataLayer = window.dataLayer || [];
  window.mpjTrack = window.mpjTrack || function (eventName, params) {
    try {
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) {}
  };

  document.addEventListener("click", function (e) {
    var el = e.target.closest ? e.target.closest("[data-mpj-track]") : null;
    if (!el) return;
    /* Les boutons du tunnel (suivant / valider) sont suivis apres validation, voir plus bas */
    if (el.hasAttribute("data-mpj-next") || el.hasAttribute("data-mpj-submit")) return;
    window.mpjTrack(el.getAttribute("data-mpj-track"), {
      package: el.getAttribute("data-mpj-package") || undefined,
      location: el.getAttribute("data-mpj-location") || undefined
    });
  });

  /* ---------------- Reveal on scroll ---------------- */
  (function () {
    var els = document.querySelectorAll(".mpj-rv");
    if (!els.length) return;
    function revealAll() {
      els.forEach(function (el) { el.classList.add("is-in"); });
    }
    if (!("IntersectionObserver" in window)) {
      revealAll();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
    /* Filet de securite : le contenu ne doit jamais rester cache. */
    setTimeout(revealAll, 700);
  })();

  /* ---------------- Pricing view ---------------- */
  (function () {
    var pricing = document.querySelector("[data-mpj-pricing]");
    if (!pricing || !("IntersectionObserver" in window)) return;
    var seen = false;
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen) {
          seen = true;
          window.mpjTrack("pricing_view", {});
          pio.disconnect();
        }
      });
    }, { threshold: 0.35 });
    pio.observe(pricing);
  })();

  /* ---------------- Before/after slider ---------------- */
  (function () {
    document.querySelectorAll("[data-mpj-ba]").forEach(function (root) {
      var wrap = root.querySelector("[data-mpj-ba-afterwrap]");
      var handle = root.querySelector("[data-mpj-ba-handle]");
      var grip = root.querySelector("[data-mpj-ba-grip]") || root.querySelector(".mpj-ba__grip");
      if (!wrap || !handle) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.clipPath = "inset(0 0 0 " + pct + "%)";
        handle.style.left = pct + "%";
        handle.setAttribute("aria-valuenow", String(Math.round(pct)));
      }

      var dragging = false;

      function pctFromClientX(clientX) {
        var rect = root.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onMove(clientX) {
        setPos(pctFromClientX(clientX));
      }

      var trackContext = root.getAttribute("data-mpj-ba-context") || "generic";
      var tracked = false;
      function trackOnce() {
        if (!tracked) { tracked = true; window.mpjTrack("before_after_interaction", { context: trackContext }); }
      }

      root.addEventListener("pointerdown", function (e) {
        dragging = true;
        root.setPointerCapture(e.pointerId);
        onMove(e.clientX);
        trackOnce();
      });
      root.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        onMove(e.clientX);
      });
      root.addEventListener("pointerup", function () { dragging = false; });
      root.addEventListener("pointercancel", function () { dragging = false; });

      handle.setAttribute("tabindex", "0");
      handle.setAttribute("role", "slider");
      handle.setAttribute("aria-label", "Curseur avant / après");
      handle.setAttribute("aria-valuemin", "0");
      handle.setAttribute("aria-valuemax", "100");

      handle.addEventListener("keydown", function (e) {
        var current = parseFloat(handle.style.left) || 50;
        if (e.key === "ArrowLeft") { setPos(current - 5); trackOnce(); e.preventDefault(); }
        if (e.key === "ArrowRight") { setPos(current + 5); trackOnce(); e.preventDefault(); }
      });

      setPos(50);

      /* Suggestion visuelle unique au premier passage dans le viewport. */
      if (grip && "IntersectionObserver" in window) {
        var nudged = false;
        var nudgeIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !nudged) {
              nudged = true;
              grip.classList.add("mpj-nudge");
              setTimeout(function () { grip.classList.remove("mpj-nudge"); }, 1400);
              nudgeIo.disconnect();
            }
          });
        }, { threshold: 0.6 });
        nudgeIo.observe(root);
      }
    });
  })();

  /* ---------------- Style switcher (meme jardin, plusieurs styles) ---------------- */
  (function () {
    document.querySelectorAll("[data-mpj-style-switcher]").forEach(function (root) {
      var img = root.querySelector("[data-mpj-style-image]");
      var tabs = root.querySelectorAll("[data-mpj-style-tab]");
      var toggle = root.querySelector("[data-mpj-style-toggle]");
      var beforeUrl = root.getAttribute("data-mpj-before-url");
      if (!img || !tabs.length) return;
      var showingOriginal = false;

      function activate(tab) {
        tabs.forEach(function (t) { t.classList.toggle("is-active", t === tab); });
        if (!showingOriginal) img.src = tab.getAttribute("data-mpj-style-image-url");
        window.mpjTrack("style_switch_click", { style: tab.textContent.trim() });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          if (showingOriginal) {
            showingOriginal = false;
            if (toggle) toggle.classList.remove("is-active");
          }
          activate(tab);
        });
      });

      if (toggle && beforeUrl) {
        toggle.addEventListener("click", function () {
          showingOriginal = !showingOriginal;
          toggle.classList.toggle("is-active", showingOriginal);
          if (showingOriginal) {
            img.src = beforeUrl;
          } else {
            var activeTab = root.querySelector("[data-mpj-style-tab].is-active") || tabs[0];
            if (activeTab) img.src = activeTab.getAttribute("data-mpj-style-image-url");
          }
        });
      }
    });
  })();

  /* ---------------- Envoi des photos (stockage Supabase) ----------------
     Les photos sont envoyees directement depuis le navigateur pendant que le client remplit
     le formulaire. Les liens sont ecrits dans le champ cache properties[photo_urls], donc
     presents dans la commande Shopify. Le dossier est en depot seul (pas de lecture en liste). */
  var MPJ_UP = {
    url: "https://azerkvylwslqagqnsmci.supabase.co",
    key: "sb_publishable_-XsfAdY6_DEx2nW-7BfWww_q9A2cwW3",
    bucket: "projets",
    maxPhotos: 8,
    maxBytes: 10 * 1024 * 1024,
    maxSide: 2000
  };
  window.__mpjPhotos = { items: [], busy: 0, message: function () {}, check: function () { return true; } };

  function mpjPrepare(file) {
    return new Promise(function (resolve) {
      var okType = /^image\/(jpeg|png|webp|heic)$/.test(file.type);
      function original() {
        resolve(okType && file.size <= MPJ_UP.maxBytes ? { blob: file, type: file.type, preview: "" } : null);
      }
      if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) return resolve(null);
      var objUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var k = Math.min(1, MPJ_UP.maxSide / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement("canvas");
        c.width = Math.max(1, Math.round(img.naturalWidth * k));
        c.height = Math.max(1, Math.round(img.naturalHeight * k));
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) {
          if (b) resolve({ blob: b, type: "image/jpeg", preview: objUrl });
          else original();
        }, "image/jpeg", 0.86);
      };
      img.onerror = original; /* ex. HEIC illisible par ce navigateur : on envoie l'original s'il est autorise */
      img.src = objUrl;
    });
  }

  function mpjSend(item, path) {
    return fetch(MPJ_UP.url + "/storage/v1/object/" + MPJ_UP.bucket + "/" + path, {
      method: "POST",
      headers: { apikey: MPJ_UP.key, Authorization: "Bearer " + MPJ_UP.key, "Content-Type": item.type },
      body: item.blob
    }).then(function (r) {
      if (!r.ok) throw new Error("upload " + r.status);
      return MPJ_UP.url + "/storage/v1/object/public/" + MPJ_UP.bucket + "/" + path;
    });
  }

  function mpjSessionId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return String(Date.now()) + "-" + Math.random().toString(36).slice(2, 10);
  }

  /* ---------------- Wizard (funnel /commencer) ---------------- */
  (function () {
    var forms = document.querySelectorAll("[data-mpj-wizard]");
    forms.forEach(function (form) {
      var steps = form.querySelectorAll("[data-mpj-step]");
      var current = 0;

      /* Case obligatoire du dernier ecran : execution immediate + renonciation au droit de retractation (CGV art. 7).
         Enregistree dans la commande (propriete consentement_execution_immediate) comme preuve. */
      (function () {
        if (!steps.length || form.querySelector('[name="properties[consentement_execution_immediate]"]')) return;
        var nav = steps[steps.length - 1].querySelector(".mpj-wizard__nav");
        if (!nav) return;
        var f = document.createElement("div");
        f.className = "mpj-field";
        f.style.marginTop = "18px";
        f.innerHTML = '<label style="display:flex;gap:10px;align-items:flex-start;cursor:pointer;">' +
          '<input type="checkbox" name="properties[consentement_execution_immediate]" value="Oui" data-mpj-required style="margin-top:3px;flex:none;width:18px;height:18px;">' +
          '<span style="font-size:14px;line-height:1.45;color:var(--mpj-text-soft);">Je demande l\'exécution immédiate de mon projet et je reconnais perdre mon droit de rétractation une fois celui-ci livré. J\'ai lu les <a href="/pages/cgv" target="_blank" rel="noopener">conditions générales de vente</a>.</span>' +
          '</label><div class="mpj-error"></div>';
        nav.parentNode.insertBefore(f, nav);
      })();

      function required(step) {
        return step.querySelectorAll("[data-mpj-required]");
      }

      function validateStep(step) {
        var ok = true;
        required(step).forEach(function (field) {
          var group = field.closest("[data-mpj-required-group]");
          var filled;
          if (field.type === "radio" || field.type === "checkbox") {
            var name = field.name;
            filled = !!form.querySelector('[name="' + name + '"]:checked');
          } else {
            filled = field.value && field.value.trim() !== "";
          }
          var err = (group || field.closest(".mpj-field"))?.querySelector(".mpj-error");
          if (!filled) {
            ok = false;
            if (err) { err.textContent = "Ce champ est requis."; err.classList.add("mpj-error--visible"); }
          } else if (err) {
            err.textContent = ""; err.classList.remove("mpj-error--visible");
          }
        });
        /* Photos : au moins une, et aucun envoi en cours */
        if (step.querySelector("[data-mpj-photo-box]") && !window.__mpjPhotos.check()) ok = false;
        return ok;
      }

      function updateProgress() {
        var label = form.querySelector("[data-mpj-progress-label]");
        var fill = form.querySelector("[data-mpj-progress-fill]");
        if (label) label.textContent = (current + 1) + " / " + steps.length;
        if (fill) fill.style.width = (((current + 1) / steps.length) * 100) + "%";
      }

      function show(index) {
        steps.forEach(function (s, i) { s.classList.toggle("is-active", i === index); });
        current = index;
        updateProgress();
        window.scrollTo({ top: form.offsetTop - 40, behavior: "smooth" });
        window.mpjTrack("project_form_step_" + (index + 1), {});
      }

      form.querySelectorAll("[data-mpj-next]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (!validateStep(steps[current])) return;
          var ev = btn.getAttribute("data-mpj-track");
          if (ev) window.mpjTrack(ev, {});
          if (current < steps.length - 1) show(current + 1);
        });
      });
      form.querySelectorAll("[data-mpj-prev]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (current > 0) show(current - 1);
        });
      });

      /* Recap sur le dernier ecran */
      var recapPackage = form.querySelector("[data-mpj-recap-package]");
      var recapType = form.querySelector("[data-mpj-recap-type]");
      var recapPhotos = form.querySelector("[data-mpj-recap-photos]");
      var recapBudget = form.querySelector("[data-mpj-recap-budget]");
      function updateRecap() {
        if (recapType) {
          var t = form.querySelector('[name="properties[outdoor_type]"]:checked');
          recapType.textContent = t ? t.value : "—";
        }
        if (recapBudget) {
          var b = form.querySelector('[name="properties[budget_range]"]:checked');
          recapBudget.textContent = b ? b.value : "—";
        }
        if (recapPackage) {
          var p = form.querySelector('[name="properties[selected_package]"]:checked');
          recapPackage.textContent = p ? p.value : "—";
        }
        if (recapPhotos) {
          var n = window.__mpjPhotos.items.length;
          recapPhotos.textContent = n ? n + " photo(s)" : "—";
        }
      }
      form.addEventListener("change", updateRecap);
      form.addEventListener("mpj:photos", updateRecap);

      /* Prix du bouton + variante Shopify selon la formule */
      var submitBtn = form.querySelector("[data-mpj-submit]");
      var variantInput = form.querySelector("[data-mpj-variant-input]");
      var priceByPackage = { "Vision": "49,90 €", "Projet Complet": "89,90 €", "Grand Extérieur": "129,90 €" };
      var variantMap = {};
      try { variantMap = JSON.parse(form.getAttribute("data-mpj-variant-map") || "{}"); } catch (e) {}

      function syncPackage() {
        var p = form.querySelector('[name="properties[selected_package]"]:checked');
        if (!p) return;
        var shortName = p.getAttribute("data-mpj-package-name");
        if (submitBtn && shortName && priceByPackage[shortName]) {
          submitBtn.textContent = "Valider mon projet — " + priceByPackage[shortName];
        }
        if (variantInput && variantMap[p.value]) {
          variantInput.value = variantMap[p.value];
        }
      }
      /* Formule preselectionnee par le lien du pricing (?package=vision|complet|grand) */
      (function () {
        var q = "";
        try { q = (new URLSearchParams(window.location.search).get("package") || "").toLowerCase(); } catch (e) {}
        var map = { vision: "Vision", complet: "Projet Complet", grand: "Grand Extérieur" };
        if (!map[q]) return;
        var r = form.querySelector('[name="properties[selected_package]"][data-mpj-package-name="' + map[q] + '"]');
        if (r) r.checked = true;
      })();
      form.addEventListener("change", syncPackage);
      syncPackage();

      if (submitBtn) {
        submitBtn.addEventListener("click", function () {
          if (!validateStep(steps[steps.length - 1])) return;
          /* Garde-fou : jamais de commande sans photo ni pendant un envoi */
          if (window.__mpjPhotos.busy > 0 || !window.__mpjPhotos.items.length) {
            window.__mpjPhotos.check();
            show(0);
            return;
          }
          syncPackage();
          var p = form.querySelector('[name="properties[selected_package]"]:checked');
          window.mpjTrack(submitBtn.getAttribute("data-mpj-track") || "checkout_started", { package: p ? p.getAttribute("data-mpj-package-name") : undefined });
          form.submit();
        });
      }

      if (steps.length) show(0);
    });

    /* Envoi reel des photos + miniatures */
    document.querySelectorAll("[data-mpj-photo-box]").forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      var title = box.querySelector("[data-mpj-photo-title]");
      var form = box.closest("form");
      var hidden = form ? form.querySelector('input[name="properties[photo_urls]"]') : null;
      if (!input || !hidden) return;
      var P = window.__mpjPhotos;
      var sessionId = mpjSessionId();
      var counter = 0;
      var defaultTitle = title ? title.textContent : "";

      var msg = document.createElement("p");
      msg.style.cssText = "margin:8px 0 0;font-size:13.5px;font-weight:600;color:#C0392B;display:none;";
      var thumbs = document.createElement("div");
      thumbs.style.cssText = "display:flex;flex-wrap:wrap;gap:10px;margin-top:12px;";
      box.parentNode.insertBefore(thumbs, box.nextSibling);
      box.parentNode.insertBefore(msg, thumbs.nextSibling);

      P.message = function (text, isError) {
        msg.textContent = text || "";
        msg.style.color = isError ? "#C0392B" : "#5C6A62";
        msg.style.display = text ? "block" : "none";
      };
      P.check = function () {
        if (P.busy > 0) { P.message("Envoi des photos en cours, quelques secondes de patience…", true); return false; }
        if (!P.items.length) { P.message("Ajoutez au moins une photo de votre extérieur pour continuer.", true); return false; }
        P.message("");
        return true;
      };

      function refresh() {
        hidden.value = P.items.map(function (i) { return i.url; }).join(", ");
        thumbs.innerHTML = "";
        P.items.forEach(function (it, idx) {
          var cell = document.createElement("div");
          cell.style.cssText = "position:relative;width:72px;height:72px;border-radius:10px;overflow:hidden;background:#E9E5D9;";
          if (it.preview) {
            var im = document.createElement("img");
            im.src = it.preview; im.alt = "";
            im.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
            cell.appendChild(im);
          }
          var rm = document.createElement("button");
          rm.type = "button"; rm.textContent = "×"; rm.setAttribute("aria-label", "Retirer cette photo");
          rm.style.cssText = "position:absolute;top:3px;right:3px;width:22px;height:22px;border:0;border-radius:50%;background:rgba(0,0,0,.65);color:#fff;font-size:15px;line-height:22px;cursor:pointer;padding:0;";
          rm.addEventListener("click", function (ev) { ev.stopPropagation(); P.items.splice(idx, 1); refresh(); });
          cell.appendChild(rm);
          thumbs.appendChild(cell);
        });
        if (title) {
          if (P.busy > 0) title.textContent = "Envoi en cours…";
          else title.textContent = P.items.length ? P.items.length + " photo(s) ajoutée(s) · cliquez pour en ajouter" : defaultTitle;
        }
        form.dispatchEvent(new Event("mpj:photos"));
      }

      box.addEventListener("click", function (e) {
        if (e.target !== input) input.click();
      });

      input.addEventListener("change", function () {
        var files = Array.prototype.slice.call(input.files || []);
        input.value = "";
        if (!files.length) return;
        var room = MPJ_UP.maxPhotos - P.items.length;
        if (room <= 0) { P.message("Maximum " + MPJ_UP.maxPhotos + " photos. Retirez-en une pour en ajouter.", true); return; }
        if (files.length > room) { files = files.slice(0, room); P.message("Seules les " + room + " premières photos ont été retenues (maximum " + MPJ_UP.maxPhotos + ").", true); }
        else P.message("");
        var failed = 0;
        files.forEach(function (file) {
          P.busy++; refresh();
          mpjPrepare(file).then(function (item) {
            if (!item) throw new Error("format");
            counter++;
            var ext = item.type === "image/png" ? "png" : item.type === "image/webp" ? "webp" : item.type === "image/heic" ? "heic" : "jpg";
            return mpjSend(item, "uploads/" + sessionId + "/" + counter + "." + ext).then(function (url) {
              P.items.push({ url: url, preview: item.preview });
            });
          }).catch(function () {
            failed++;
          }).then(function () {
            P.busy--;
            refresh();
            if (P.busy === 0) {
              if (failed) P.message(failed + " photo(s) n'ont pas pu être envoyées (format non accepté ou connexion). Réessayez avec des JPG ou PNG.", true);
              if (P.items.length) window.mpjTrack("photos_uploaded", { count: P.items.length });
            }
          });
        });
      });
    });
  })();

  /* ---------------- Header scroll state ---------------- */
  (function () {
    var header = document.querySelector(".mpj-site-header");
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();
}
